<template>
  <el-form-item
    :id="erpHotPointId"
    :class="item.type === 'area' ? 'item-area' : ''"
    :label="item.type === 'area' ? ' ' : item.label"
    :operation="operationLabel"
    :prop="item.propertyName"
    :rules="item.attr && item.attr.rules">
    <!-- slot label -->
    <formatter v-if="item.formatterLabel" slot="label" :formatter="item.formatterLabel" :option="item" />
    <el-radio
      v-else-if="item.labelType === 'radio' && item.labelModel"
      slot="label"
      :label="item.propertyName"
      v-model="model[item.labelModel]"
      @change="e => item.labelChange && item.labelChange(e, model, item)">{{ item.label }}
    </el-radio>
    <!-- slot default -->
    <formatter v-if="item.formatter" :option="item" :model="model" />
    <el-input
      v-else-if="item.type === 'dept'"
      :style="item.width ? {width: item.width} : null"
      :disabled="isDisabled(item)"
      :placeholder="item.placeholder"
      readonly
      v-bind="bindAttr"
      :value="showDeptLabel"
      @click.native="openDeptTree(item)"
      @focus="focus = true"
      @blur="focus = false"
      @mouseenter.native="focus = true"
      @mouseleave.native="focus = false">
      <i
        slot="suffix"
        v-show="focus && showDeptLabel"
        class="el-input__icon el-icon-circle-close el-input__clear"
        @click.stop="clearDept">
      </i>
    </el-input>
    <kye-dept-select
      v-else-if="item.type === 'deptSelect'"
      :style="item.width ? {width: item.width} : null"
      :placeholder="item.placeholder"
      :disabled="isDisabled(item)"
      v-bind="bindAttr"
      :value="bindValue(item.propertyName)"
      @input="bindChange"
      @change="deptSelectChange">
    </kye-dept-select>
    <kye-number
      v-else-if="item.type === 'number'"
      :style="item.width ? {width: item.width} : null"
      :disabled="isDisabled(item)"
      :placeholder="item.placeholder"
      v-bind="bindAttr"
      :value="bindValue(item.propertyName)"
      @input="bindChange">
    </kye-number>
    <el-input
      v-else-if="item.type === 'text'"
      :style="item.width ? {width: item.width} : null"
      :disabled="isDisabled(item)"
      :placeholder="item.placeholder"
      v-bind="bindAttr"
      :value="bindValue(item.propertyName)"
      @input="bindChange">
    </el-input>
    <kye-select
      v-else-if="item.type === 'select'"
      :style="item.width ? {width: item.width} : null"
      :disabled="isDisabled(item)"
      :placeholder="item.placeholder"
      default-first-option
      v-bind="bindAttr"
      :value="bindValue(item.propertyName)"
      :labels="selectedLabels"
      @input="bindChange"
      @visible-change="selectVisibleChange">
      <kye-option
        v-for="(opt, i) in item.options"
        :key="opt.value+i"
        :disabled="opt.disabled"
        :label="opt.label || ' '"
        :value="opt.value">
      </kye-option>
    </kye-select>
    <kye-select
      v-else-if="item.type === 'remoteSelect'"
      :style="item.width ? {width: item.width} : null"
      :disabled="isDisabled(item)"
      :placeholder="item.placeholder"
      remote
      :user="item.user"
      :remote-method="remoteMethod"
      :loading="item.loading"
      v-bind="bindAttr"
      :value="bindValue(item.propertyName)"
      :labels="selectedLabels"
      ref="remoteSelect"
      @input="bindChange"
      @visible-change="selectVisibleChange">
      <!-- <i slot="prefix" class="el-icon-search" style="padding-top:8px;padding-left:4px;"></i> -->
      <kye-option
        v-for="(opt, i) in item.options"
        :class="opt.optionDisabled ? 'kyeuseroff' : ''"
        :key="opt.value+i"
        :label="opt.label"
        :value="opt.value">
      </kye-option>
    </kye-select>
    <el-autocomplete
      v-else-if="item.type === 'autocomplete'"
      ref="autocomplete"
      popper-class="kye-popper-auto"
      :style="item.width ? {width: item.width} : null"
      :disabled="isDisabled(item)"
      :placeholder="item.placeholder"
      :trigger-on-focus="false"
      :fetch-suggestions="fetchSuggestions"
      v-bind="bindAttr"
      :value="bindValue(item.propertyName)"
      @blur="bindBlur"
      @input="bindChange"
      @select="bindSelect">
      <span slot-scope="scope" :class="scope.item.optionDisabled ? 'kyeuseroff' : ''">{{scope.item.label}}</span>
    </el-autocomplete>
    <kye-date-picker
      v-else-if="item.type === 'datePicker'"
      :style="item.width ? {width: item.width} : null"
      :disabled="isDisabled(item)"
      :placeholder="item.placeholder"
      :type="item.dateType || 'date'"
      :format="item.format || 'yyyy-MM-dd'"
      :format2="item.format2"
      :value-format="item.valueFormat || 'yyyy-MM-dd HH:mm:ss'"
      :operation="item.operation"
      v-bind="bindAttr"
      :value="bindValue(item.propertyName)"
      @input="datePickerChange">
    </kye-date-picker>
    <kye-date-picker3
      v-else-if="item.type === 'datePicker3'"
      :style="item.width ? {width: item.width} : null"
      :disabled="isDisabled(item)"
      :placeholder="item.placeholder"
      :type="item.dateType"
      :format="item.format"
      :format2="item.format2"
      :value-format="item.valueFormat"
      :operation="item.operation"
      v-bind="bindAttr"
      :value="bindValue(item.propertyName)"
      @input="datePickerChange">
    </kye-date-picker3>
    <kye-date-picker2
      v-else-if="item.type === 'datePicker2'"
      :style="item.width ? {width: item.width} : null"
      :disabled="isDisabled(item)"
      :placeholder="item.placeholder"
      :startPlaceholder="item.startPlaceholder"
      :endPlaceholder="item.endPlaceholder"
      :type="item.dateType"
      :format="item.format"
      :value-format="item.valueFormat"
      :operation="item.operation"
      v-bind="bindAttr"
      :value="bindValue(item.propertyName)"
      @input="datePickerChange">
    </kye-date-picker2>
    <kye-time-picker
      v-else-if="item.type === 'timePicker'"
      :style="item.width ? {width: item.width} : null"
      :is-range="item.dateType === 'range'"
      :format="item.format || 'HH:mm:ss'"
      :value-format="item.valueFormat || 'HH:mm:ss'"
      v-bind="bindAttr"
      :value="bindValue(item.propertyName)"
      @input="datePickerChange">
    </kye-time-picker>
    <kye-area-remote
      v-else-if="item.type === 'area'"
      show-label
      :show-placeholder="false"
      :style="item.width ? {width: item.width} : null"
      :disabled="isDisabled(item)"
      :level="item.options.length"
      :labels="item.options.map(v => v.label)"
      :value="bindValue(item.propertyName)"
      @input="e => bindChange(e)">
    </kye-area-remote>
    <ul
      v-else-if="item.type === 'range'"
      class="item-range"
      :style="item.width ? {width: item.width} : {width: '200px'}">
      <li
        v-for="(opt, i) in rangeOptions"
        :key="opt.propertyName+i">
        <kye-number
          v-if="opt.type === 'number'"
          :symbol="opt.prepend"
          :unit="opt.append"
          v-bind="opt.attr"
          :value="bindValue(opt.propertyName)"
          @input="e => bindChange(e, opt)">
        </kye-number>
        <span v-else-if="opt.type === 'separator'">{{ item.attr.separator }}</span>
        <el-input
          v-else
          :placeholder="opt.placeholder"
          v-bind="opt.attr"
          :value="bindValue(opt.propertyName)"
          @input="e => bindChange(e, opt)">
          <template v-if="opt.prepend" slot="prepend">{{ opt.prepend }}</template>
          <template v-if="opt.append" slot="append">{{ opt.append }}</template>
        </el-input>
      </li>
    </ul>
  </el-form-item>
</template>

<script>
  import mixins from '../../mixins'
  import Formatter from './form-item-formatter'
  import {
    getModelValue,
    setModelValue,
  } from '../../utils'
  import {
    OPERATION_LABELS,
    getRemoteOptions,
    remoteSelectMethod,
    navigateSelectFirstOption
  } from './utils'

  export default {
    name: 'form-item',
    mixins: [mixins],
    components: { Formatter },
    props: {
      item: Object,
      model: Object,
      fields: Array,
      XPathHash: String,
    },
    data () {
      return {
        focus: false,
      }
    },
    computed: {
      erpHotPointId() {
        return 'ERP_HOT_' + this.XPathHash + '_' + this.item.propertyName
      },
      bindAttr () {
        if (!this.item.attr) {
          return { clearable: !this.item.required }
        }
        if (!this.item.attr.hasOwnProperty('clearable')) {
          // eslint-disable-next-line
          this.item.attr.clearable = !this.item.required
        }
        return this.item.attr
      },
      showDeptLabel () {
        let arr = this.item._queryValue
        if (arr && arr.length) {
          return arr.map(v => v.label).join()
        }
        return ''
      },
      operationLabel () {
        return OPERATION_LABELS[this.item.operation] || ''
      },
      itemOptionsMap () {
        return Array.isArray(this.item.options) ? this.item.options.reduce((s, v) => {
          s[v.value] = v.label
          return s
        }, {}) : {}
      },
      rangeOptions () {
        const options = this.item.options
        const isSeparator = this.item.attr && this.item.attr.separator
        if (isSeparator) {
          let arr = []
          options.forEach((item, index) => {
            arr.push({ ...item })
            if (index !== options.length - 1) {
              arr.push({ type: 'separator', propertyName: 'separator' })
            }
          })
          return arr
        }
        return options
      },
      // 获取多选下拉框选中的 labels，用于抓取导出查询参数的dom文本
      selectedLabels () {
        if (this.item.attr && this.item.attr.multiple) {
          let val = getModelValue(this.model, this.item.propertyName)
          if (Array.isArray(val)) {
            return JSON.stringify(val.map(v => this.itemOptionsMap[v]))
          }
          return ''
        }
        return ''
      }
    },
    methods: {
      bindValue (key) {
        const item = this.item
        const val = getModelValue(this.model, key)
        // 防止出现脏数据导致报错无法二次操作
        if (item.type === 'select' && item.attr && item.attr.multiple && !val) {
          return []
        }
        return val
      },
      bindChange (value, opt = this.item) {
        if (value && typeof value === 'string') {
          value = value.trim()
        }
        let key = opt.propertyName
        setModelValue(value, this.model, key)
        if (opt.type !== 'deptSelect') {
          opt.change && opt.change({ key, value, model: this.model, fields: this.fields })
        }
      },
      deptSelectChange (data, opt = this.item) {
        if (opt.change) {
          const key = opt.propertyName
          opt.change({ ...data, key, model: this.model, fields: this.fields })
        }
      },
      bindSelect (value) {
        let key = this.item.propertyName
        this.item.select && this.item.select({ key, value, model: this.model, fields: this.fields })
      },
      bindBlur () {
        this.item.blur && this.item.blur({ model: this.model })
      },
      datePickerChange (val) {
        let keys = this.item.valueKey
        if (keys && Array.isArray(keys)) {
          this.mergeModelInArray(val, keys, this.model)
        }
        this.bindChange(val)
      },
      selectVisibleChange (val) {
        // 远程下拉框可见时，同步下拉框
        if (val && typeof this.item.remoteMethod === 'function') {
          if (this.item.type === 'remoteSelect') {
            // 远程搜索有默认的子选项
            this.item.options = this.item.lookupCode ? this.lookUpOptions[this.item.lookupCode] : []
            if (this.item.attr && this.item.attr.multiple && this.item.allSearchResult) {
              this.item.options = Object.keys(this.item.allSearchResult).reduce((prev, key) => {
                if (this.bindValue(this.item.propertyName).includes(key)) {
                  const obj = this.item.allSearchResult[key]
                  prev.push(obj)
                }
                return prev
              }, this.item.options)
            }
          } else if (this.item.type === 'select') {
            getRemoteOptions(this.item, this.model)
          }
        }
      },
      async remoteMethod (val) {
        let arr = await remoteSelectMethod(val, this.item)
        if (arr.length) {
          // 自动选中第一行
          this.$nextTick(_ => navigateSelectFirstOption(this.$refs.remoteSelect))
        }
      },
      async fetchSuggestions (val, cb) {
        let arr = await remoteSelectMethod(val, this.item)
        cb(arr)
        if (arr.length) {
          // 自动选中第一行
          this.$nextTick(_ => {
            let ref = this.$refs.autocomplete
            ref && ref.highlight && ref.highlight(0)
          })
        } else {
          this.$refs.autocomplete.$emit('select', { [this.item.labelKey]: val })
        }
      },
      mergeModelInArray (val, keys, model) {
        keys.forEach((v, i) => {
          setModelValue((val && val[i]), model, v)
        })
      },
      isDisabled (item) {
        if (typeof item.disabled === 'function') {
          let obj = { key: item.propertyName, model: this.model }
          return item.disabled(obj)
        }
        return !!item.disabled
      },
      openDeptTree (field) {
        if (this.isDisabled(field)) {
          return
        }
        this.$emit('open-dept-tree', field)
      },
      clearDept () {
        let key = this.item.propertyName
        this.item._queryValue = null
        setModelValue(null, this.model, key)
        this.$set(this.model, `_deptContainLeaf_${key}`, null)
        this.$set(this.model, `_deptInfo_${key}`, null)
        let fn = this.item.change
        if (fn && typeof fn === 'function') {
          fn({ key, value: null, model: this.model })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/public/components/query-table/form-item.vue